import WGLLog from './logger';

class WGLFBO {
  constructor(gl, key) {
    this.key = key;
    this.id = gl.createFramebuffer();

    this._logInfo('Created');
  }

  _logInfo(msg) {
    WGLLog.info('FBO', this.key, msg);
  }

  bind(gl) {
    const { id } = this;
    gl.bindFramebuffer(gl.FRAMEBUFFER, id);
  }

  unbind(gl) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  }

  free(gl) {
    const { id } = this;
    gl.deleteFramebuffer(id);

    this._logInfo('Deleted');
  }
}

export default WGLFBO;
